import React from "react";
import { Button, FormGroup } from "react-bootstrap";
import { useFormContext } from "./Form";
import { observer } from "mobx-react-lite";
import { values, isObservableObject } from "mobx";
import { useTranslation } from "./hooks/useTranslation";
import { useButtonClasses } from "./Button/Button.styles";
import { classNames } from "./utils/classNames";
export var hasErrors = function (error) {
    if (isObservableObject(error)) {
        return values(error).some(hasErrors);
    }
    return error === "error";
};
var BUTTON_TYPE = "primary";
export var Submit = observer(function (_a) {
    var label = _a.label, _b = _a.inline, inline = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, isDirty = _a.isDirty, id = _a.id, dataId = _a.dataId, dataTestId = _a.dataTestId, className = _a.className, _d = _a.dataHook, dataHook = _d === void 0 ? "submit-button" : _d;
    var _e = useFormContext(), errors = _e.errors, formDisabled = _e.formDisabled;
    var t = useTranslation();
    if (label === undefined) {
        label = t("Submit");
    }
    var classes = useButtonClasses(BUTTON_TYPE);
    var disabledFromErrors = hasErrors(errors);
    var button = (React.createElement(Button, { type: "submit", disabled: disabled || disabledFromErrors || formDisabled || isDirty === false, bsStyle: BUTTON_TYPE, id: id, "data-testid": dataTestId, "data-id": dataId, className: classNames(classes.button, className !== null && className !== void 0 ? className : ""), "data-hook": dataHook }, label));
    return !inline ? React.createElement(FormGroup, null, button) : button;
});
